import { createAction } from '@reduxjs/toolkit';

import {
  USER_GET_REQUEST,
  USER_GET_SUCCESS,
  USER_GET_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  USER_LOGOUT_REQUEST,
  UNREAD_MESSAGE_COUNT_START,
  UNREAD_MESSAGE_COUNT_STOP,
  UNREAD_MESSAGE_COUNT_REQUEST,
  UNREAD_MESSAGE_COUNT_SUCCESS,
} from './user.const';

export const userGetRequestAction = createAction(USER_GET_REQUEST);
export const userGetSuccessAction = createAction(USER_GET_SUCCESS);
export const userGetFailureAction = createAction(USER_GET_FAILURE);

export const forgotPasswordRequestAction = createAction(FORGOT_PASSWORD_REQUEST);

export const userLogoutRequestAction = createAction(USER_LOGOUT_REQUEST);

export const unreadMessageCountStartAction = createAction(UNREAD_MESSAGE_COUNT_START);
export const unreadMessageCountStopAction = createAction(UNREAD_MESSAGE_COUNT_STOP);
export const unreadMessageCountRequestAction = createAction(UNREAD_MESSAGE_COUNT_REQUEST);
export const unreadMessageCountSuccessAction = createAction(UNREAD_MESSAGE_COUNT_SUCCESS);
